module.exports = __webpack_public_path__ + "img/20200512_162615.23db130f.jpg";